// OnboardingContext.js
import { createContext, useContext, useState, } from 'react';

const OnboardingContext = createContext();

export const OnboardingProvider = ({ children }) => {
  const [cognitoData, setCognitoData] = useState({});
  const [inviteData, setInviteData] = useState({});
  const [buyerData, setBuyerDataState] = useState(() => {
 
    const saved = localStorage.getItem("buyerData");
    return saved ? JSON.parse(saved) : null;
  });

  const setBuyerData = (data) => {
    setBuyerDataState(data);
    localStorage.setItem("buyerData", JSON.stringify(data));
  };

  return (
    <OnboardingContext.Provider 
      value={{ 
        cognitoData, setCognitoData, 
        inviteData, setInviteData,
        buyerData, setBuyerData
      }}
    >
      {children}
    </OnboardingContext.Provider>
  );
};

export const useOnboarding = () => useContext(OnboardingContext);
